import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InSubject } from '@atmi/core/utils';

import { BehaviorSubject, combineLatest } from 'rxjs';
import { distinctUntilChanged, filter, switchMap } from 'rxjs/operators';

import { Term } from '@atmi/core/models';
import { VocabularyService } from '@atmi/core/services/vocabulary.service';

/**
 * TODO:
 *
 * - [ ] Try to replace with SelectControlValueAccessor
 */
@Component({
  providers: [{
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputVocabularyAutocompleteComponent),
  }],
  selector: 'app-input-vocabulary-autocomplete',
  styleUrls: ['./input-vocabulary-autocomplete.component.scss'],
  templateUrl: './input-vocabulary-autocomplete.component.html',
})
export class InputVocabularyAutocompleteComponent implements ControlValueAccessor {

  /** Internal value used to contain the current input selection. */
  value?: string;
  /** Internal extended value if the list of items is a complex object (in this case: Term) */
  extendedValue?: Term;
  /** Internal disable state used to disable/enable the ng-select component. */
  readonly isDisabled$ = new BehaviorSubject(false);
  /** Internal state used to check if ng-select has been focus. */
  readonly isOnFocus$ = new BehaviorSubject(false);

  @Input() openVocabulary = true;

  @Input() bindLabel = 'valore';
  @Input() bindValue = 'valore';

  @Input() placeholder = '';

  @Input() @InSubject() vocabularyName?: string;
  readonly vocabularyNameChange = new BehaviorSubject<string | undefined>(undefined);

  @Input() @InSubject() parentTerm?: Term;
  readonly parentTermChange = new BehaviorSubject<Term | undefined>(undefined);

  readonly terms$ = combineLatest([
    this.vocabularyNameChange.pipe(filter((name): name is string => !!name)),
    this.parentTermChange,
    this.isOnFocus$.pipe(filter((isOnFocus) => !!isOnFocus)),
    this.isDisabled$.pipe(
      filter((isDisabled) => !isDisabled),
      distinctUntilChanged(),
    ),
  ]).pipe(
    switchMap(([name, parentTerm]) => this.vocabularyApi.searchTerms('', name, parentTerm)),
  );

  private onChange!: (_: any) => void;
  private onTouched!: () => void;

  constructor(
    private readonly vocabularyApi: VocabularyService,
  ) {
  }

  writeValue(v?: string) {
    this.value = v;
  }

  registerOnChange(fn: (value: any) => any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => any) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.isDisabled$.next(isDisabled);
  }

  changeValueHandler(value: Term | undefined) {
    this.extendedValue = value;

    this.value = value && value.valore;

    this.onChange(value && value.valore);
  }

  onFocusHandler() {
    this.isOnFocus$.next(true);
  }

  onScrollHandler() {
    // ** PARAMS **
    // { end }: { end: number }
    // ** VARIABLES **
    // bufferSize = 50;
    // numberOfItemsFromEndBeforeFetchingMore = 10;
    // loading = false;
    // ** IMPLEMENTATION **
    // if (this.loading || this.mtcTerms.length <= this.termsBuffer.length) {
    //   return;
    // }

    // if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.termsBuffer.length) {
    //   this.fetchTerms();
    // }
  }
}
